<template>
  <div class="registrations">
      <h1 class="title">{{$t("settings.settings")}}</h1>
        <div class="columns">
            <div class="column is-3">
                  <aside class="menu">
                    <p class="menu-label">
                        {{$t("settings.persSettings")}}
                    </p>
                        <ul class="menu-list">
                            <router-link to="/settings/user" tag="li" v-bind:class="{'is-active': !navUserProjects}" exact><a>{{$t("settings.settings")}}</a></router-link>
                            <router-link to="/settings/user/templates" tag="li" v-bind:class="{'is-active': navUserTemplates}" exact><a>{{$t("settings.templates")}}</a></router-link>
                            <!-- <router-link to="/settings/user/projects" tag="li"  v-bind:class="{'is-active': navUserProjects}"><a>{{$t("settings.personal.favProjects")}}</a></router-link> -->
                        </ul>
                    <p class="menu-label" v-if="$auth.isAdmin()">
                        {{$t("settings.orgSettings")}}
                    </p>
                    <ul class="menu-list" v-if="$auth.isAdmin()">
                        <router-link to="/settings/organisation" tag="li" v-bind:class="{'is-active': !navOrgUsers}" exact><a>{{$t("settings.settings")}}</a></router-link>
                        <router-link to="/settings/organisation/users" tag="li" v-bind:class="{'is-active': navOrgUsers}"><a>{{$t("settings.users")}}</a></router-link>
                        <!-- <router-link to="/settings/organisation/resources" tag="li" v-bind:class="{'is-active': navOrgResources}"><a>{{$t("settings.resources")}}</a></router-link> -->
                    </ul>
                </aside>
            </div>
            <div class="column">
                <SettingsOrg v-if="$route.params.nav === 'organisation'"/>
                <SettingsUser v-if="$route.params.nav === 'user' || (!this.$route.params.nav && !this.$route.params.nav2)"/>
            </div>
        </div>
  </div>
</template>

<script>
import moment from 'moment'
import SettingsUser from '@/components/settings/SettingsUser.vue'
import SettingsOrg from '@/components/settings/SettingsOrg.vue'

export default {
  name: 'settings',
  components: {
      SettingsUser,
      SettingsOrg
  },
   data: function() {
       return {
       }
   },
   computed: {
       navUserTemplates() {
        if(this.$route.params.nav2 === 'templates') {
               return true;
           } else {
               return false
           }
       },
       navOrgUsers() {
        if(this.$route.params.nav2 === 'users') {
               return true;
           } else {
               return false
           }
       },
       navOrgResources() {
        if(this.$route.params.nav2 === 'resources') {
               return true;
           } else {
               return false
           }
       },
       navUserProjects() {
           if(this.$route.params.nav2 === 'projects') {
               return true;
           } else {
               return false
           }
       }
   }
}
</script>
<style scoped>
    .router-link-active {
        background-color: #00d1b2;
        color: #fff;
    }
</style>

